import React, { useEffect, useRef, useState } from "react";
import { api } from "@/lib/api";
import { LoadError, errMessage } from "@/components/LoadError";
import { ChevronDown } from "lucide-react";
import { AanleveringLezen } from "@/components/voorbereiding/AanleveringLezen";

const telling = (v) => (v && v.totaal > 0 ? ` · ${v.ingevuld}/${v.totaal} ingevuld` : "");

// v16 B2: "Eerder aangeleverd" — de eigen aanleveringen van de laatste 13 weken, alleen lezen.
export const EerderAangeleverd = ({ locatie, kpis, ververs }) => {
  const [data, setData] = useState(null);
  const [fout, setFout] = useState("");
  const [open, setOpen] = useState(null);
  const standaardGezet = useRef(false);

  const laad = () => api.get("/call-prep/eigen").then((r) => {
    setData({ ...r.data, weken: (r.data.weken || []).filter((w) => !w.doelweek) });   // v18 C6: de week van het formulier staat al op het scherm
    setFout("");
    if (!standaardGezet.current) { standaardGezet.current = true; setOpen(r.data.standaardOpen || null); }
  }).catch((e) => { if (!data) setFout(errMessage(e)); });
  useEffect(() => { laad(); }, [ververs]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <section data-testid="eerder-aangeleverd" className="max-w-2xl mt-8 space-y-2">
      <h2 className="font-heading text-base md:text-lg font-black tracking-tight text-zinc-900">Eerder aangeleverd</h2>
      {fout ? <LoadError error={fout} onRetry={laad} testid="eerder-aangeleverd-error" />
        : !data ? <div data-testid="eerder-aangeleverd-laden" className="text-sm text-zinc-400">Laden…</div>
        : data.weken.length === 0 ? <p data-testid="eerder-aangeleverd-leeg" className="text-sm text-zinc-500">Nog niets eerder aangeleverd.</p>
        : (
          <div className="bg-white border border-zinc-200 rounded-[10px] divide-y divide-zinc-200">
            {data.weken.map((w) => {
              const isOpen = open === w.week;
              return (
                <div key={w.week} data-testid={`eerder-week-${w.week}`}>
                  <button type="button" data-testid={`eerder-week-knop-${w.week}`} aria-expanded={isOpen}
                    onClick={() => setOpen(isOpen ? null : w.week)}
                    className="w-full min-h-[44px] flex items-center justify-between gap-3 px-3.5 py-2.5 text-left hover:bg-zinc-50 transition-colors">
                    <span className="text-sm text-zinc-800">
                      <span className="font-semibold">Call van {w.callLabelLang}</span> · over week {w.overWeekNr}
                      <span className={w.volledigheid?.compleet ? "text-emerald-700" : "text-amber-700"}>{telling(w.volledigheid)}</span>
                      {w.doelweek && <span className="ml-2 text-[10px] font-semibold uppercase tracking-wider text-blue-600">komende call</span>}
                    </span>
                    <ChevronDown className={`h-4 w-4 shrink-0 text-zinc-400 transition-transform ${isOpen ? "rotate-180" : ""}`} />
                  </button>
                  {isOpen && <div className="px-3.5 pb-4"><AanleveringLezen week={w.week} locatie={locatie} kpis={kpis} /></div>}
                </div>
              );
            })}
          </div>
        )}
    </section>
  );
};
